import { t } from 'i18next';
import { useFormContext } from 'react-hook-form';

import { CronJobName } from '../types';

import ControlledNumericField from 'components/shared/ControlledFields/ControlledNumericField';
import Select from 'components/shared/Select';
import { ControlledDatePicker } from 'components/shared/index';

interface Props {
  selectedJobType?: CronJobName;
  changeJobType: React.Dispatch<React.SetStateAction<CronJobName | undefined>>;
}

export const CleanupFormSection: React.FC<Props> = ({
  selectedJobType,
  changeJobType
}) => {
  const { control, setValue, reset } = useFormContext();
  const jobNameOptions: { value: CronJobName; label: string }[] = [
    {
      value: 'bpm-history-cleanup',
      label: t('cronJobs.jobs.bpm-history-cleanup')
    },
    {
      value: 'bpm-execution-cleanup',
      label: t('cronJobs.jobs.bpm-execution-cleanup')
    },
    {
      value: 'bpm-history-all-tenants-cleanup',
      label: t('cronJobs.jobs.bpm-history-all-tenants-cleanup')
    },
    {
      value: 'bpm-execution-all-tenants-cleanup',
      label: t('cronJobs.jobs.bpm-execution-all-tenants-cleanup')
    }
  ];

  return (
    <>
      <Select
        variant="outlined"
        label={t('cronJobs.form.jobName')}
        options={jobNameOptions}
        valueProp={selectedJobType}
        onSelected={(value) => {
          changeJobType(value);
          setValue('jobName', value);
          reset();
        }}
      />
      {selectedJobType != undefined && (
        <>
          <ControlledNumericField
            name="config.count"
            variant="outlined"
            label={t('cronJobs.form.bpm_cleanup_count')}
          />
          {selectedJobType != 'bpm-execution-cleanup' && (
            <>
              <ControlledDatePicker
                control={control}
                name="config.cutoffDate"
                variant="outlined"
                label={t('cronJobs.form.bpm_cleanup_cutoff_date')}
              />
              <ControlledNumericField
                name="config.batchSize"
                variant="outlined"
                label={t('cronJobs.form.bpm_cleanup_batch_size')}
              />
              <ControlledNumericField
                name="config.max"
                variant="outlined"
                label={t('cronJobs.form.bpm_cleanup_max')}
              />
              <ControlledNumericField
                name="config.maxTime"
                variant="outlined"
                label={t('cronJobs.form.bpm_cleanup_max_time')}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default CleanupFormSection;
